module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('new-team-table', {
    attrs: {
      "tableData": _vm.dshTeamList
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ctitle"
  }, [_c('h2', [_vm._v("新的数学团队")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-380400fd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/newTeamList.vue
// module id = 641
// module chunks = 6